import { formatDiffDate, ignoreTimezone } from "@enkor/date-fns";

import { ResponseProjectComment } from "@models/data-contracts";

class ProjectCommentViewModel {
  id: number;
  authorName: string;
  authorId: number;
  content: string;
  profileImage?: string;
  createdAt: string;
  replyList?: ProjectCommentViewModel[];

  static create(responseData: ResponseProjectComment) {
    const comment = new ProjectCommentViewModel();

    comment.id = responseData.id;
    comment.authorName = responseData.nickName;
    comment.authorId = responseData.userId;
    comment.profileImage = responseData.url;

    comment.content = responseData.content;
    comment.createdAt = formatDiffDate(ignoreTimezone(responseData.createdAt));

    comment.replyList =
      responseData?.replyList?.map((reply) =>
        ProjectCommentViewModel.create(reply),
      ) || [];

    return comment;
  }
}

export default ProjectCommentViewModel;
